import React from 'react';
import { Check } from 'lucide-react';
import {
  THEME_PRESETS,
  ACCENTS,
  BUTTON_STYLES,
} from '../constants';
import { CUSTOM_COLOR_GROUPS } from '../pages/admin/linksConfig.utils';
import { InfoTip, Toggle } from './LinksConfigUi';

export default function LinksConfigAppearancePanel({
  theme,
  setTheme,
  customColors,
  customColorsEnabled,
  applyPreset,
  updateAccent,
  updateCustomColor,
  toggleCustomColors,
  toggleShowIcons,
}) {
  return (
          <section className="fsl-card">
            <div className="fsl-card-head">
              <h2 className="fsl-card-title">
                Aparência
                <InfoTip text="Escolha um tema, as cores e o estilo dos botões da sua página." />
              </h2>
            </div>

            <div className="fsl-appear-group">
              <span className="fsl-appear-label">Tema</span>
              <div className="fsl-theme-grid">
                {THEME_PRESETS.map((preset) => (
                  <button
                    key={preset.id}
                    type="button"
                    className={`fsl-theme-swatch ${theme.presetId === preset.id ? 'is-sel' : ''}`}
                    onClick={() => applyPreset(preset)}
                    title={preset.name}
                  >
                    <span className="fsl-theme-thumb" style={{ background: preset.cover }}>
                      <span className="fsl-theme-thumb-card" style={{ background: preset.cardBg }}>
                        <span className="fsl-theme-dot" style={{ background: preset.defaultAccent }} />
                        <span className="fsl-theme-line" style={{ background: preset.divider }} />
                        <span className="fsl-theme-line short" style={{ background: preset.divider }} />
                      </span>
                    </span>
                    <span className="fsl-theme-name">{preset.name}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="fsl-appear-group">
              <span className="fsl-appear-label">Cor de destaque</span>
              <div className="fsl-accent-row">
                {ACCENTS.map((accent) => (
                  <button
                    key={accent.id}
                    type="button"
                    className={`fsl-accent-dot ${theme.accent === accent.value ? 'is-sel' : ''}`}
                    style={{ '--dot': accent.value }}
                    onClick={() => updateAccent(accent.value)}
                    title={accent.name}
                    aria-label={accent.name}
                  >
                    {theme.accent === accent.value && <Check size={14} strokeWidth={3} />}
                  </button>
                ))}
              </div>
            </div>

            <div className="fsl-appear-group">
              <span className="fsl-appear-label">Estilo dos botões</span>
              <div className="fsl-seg">
                {BUTTON_STYLES.map((style) => (
                  <button
                    key={style.id}
                    type="button"
                    className={`fsl-seg-btn ${theme.buttonStyle === style.id ? 'is-sel' : ''}`}
                    onClick={() => setTheme((current) => ({ ...current, buttonStyle: style.id }))}
                  >
                    {style.name}
                  </button>
                ))}
              </div>
            </div>

            <div className="fsl-inline-toggle">
              <span className="fsl-inline-toggle-title">
                Personalizar cores
                <InfoTip text="Sobrescreve as cores do tema selecionado." />
              </span>
              <Toggle
                checked={customColorsEnabled}
                onChange={toggleCustomColors}
                label="Personalizar cores"
              />
            </div>

            {customColorsEnabled && (
              <div className="fsl-custom-colors">
                {CUSTOM_COLOR_GROUPS.map((group) => (
                  <div key={group.title} className="fsl-custom-color-group">
                    <span className="fsl-custom-color-title">{group.title}</span>
                    <div className="fsl-color-grid">
                      {group.fields.map((field) => (
                        <label key={field.key} className="fsl-color-field">
                          <span>{field.label}</span>
                          <span className="fsl-color-control">
                            <input
                              type="color"
                              value={customColors[field.key]}
                              onChange={(event) => updateCustomColor(field.key, event.target.value)}
                              aria-label={field.label}
                            />
                            <em>{customColors[field.key]}</em>
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="fsl-inline-toggle">
              <span className="fsl-inline-toggle-title">
                Exibir ícone nos botões
                <InfoTip text="Mostra o ícone de cada produto e as fotos dos links. Desligado, os botões ficam só com texto centralizado." />
              </span>
              <Toggle
                checked={theme.showIcons !== false}
                onChange={toggleShowIcons}
                label="Exibir ícones nos botões"
              />
            </div>
          </section>
  );
}
